export function isInternalLink(href) {
  if (!href) {
    return false;
  }

  if (href.startsWith('#')) {
    return false;
  }

  try {
    const url = new URL(href, window.location.href);
    if (url.host === 'contributors.gitlab.com') {
      return true;
    }

    return url.origin === window.location.origin;
  } catch {
    return false;
  }
}

/**
 * Extracts the username portion of a gitlab.com profile URL.
 *
 * @param {string} url - A URL such as `https://gitlab.com/some-user`.
 * @returns {string} - The username, or an empty string if the URL is empty.
 */
export function usernameFromGitLabUrl(url) {
  return String(url || '').trim().replace(/^https?:\/\/gitlab\.com\//, '');
}
